"use strict";

// import '@babel/polyfill';

import $ from 'jquery';

// import LazyLoad from 'vanilla-lazyload';

// SimpleShare
import SimpleShare from './plugins/simpleshare/index';

// AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

import { layer } from './plugins/layer/index';

import '@splidejs/splide/css';
import Splide from '@splidejs/splide';
// import { Grid } from '@splidejs/splide-extension-grid';

// import imagesLoaded from 'imagesloaded';
// import jQueryBridget from 'jquery-bridget';
// import Masonry from 'masonry-layout';
// jQueryBridget('masonry', Masonry, $);

import validate from 'jquery-validation';
import axios from 'axios';

import 'select2/dist/css/select2.min.css';
import select2 from 'select2';

// import Highcharts from 'highcharts';

import { CountUp } from 'countup.js';


import Sticky from 'sticky-js';

import Pjax from 'pjax';

// gsap
import { gsap } from 'gsap';
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// gsap.registerPlugin(ScrollTrigger);

// import * as CookieConsent from 'vanilla-cookieconsent';
// import 'vanilla-cookieconsent/dist/cookieconsent.css';

// Lenis

import Lenis from 'lenis';

import './iconfont/iconfont';

import './plugins/jquery-citys/jquery-citys';

// import 'altcha';

// import glsl from './lygia/generative/cnoise.glsl';

import Language from './language';
const lang = new Language();

$.validator.addMethod("isMobile", function(value, element) {  
    var length = value.length;  
    var mobile = /^(1[0-9][0-9]{9})|(18[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(15[0-9]{9})$/;  
    return this.optional(element) || (length == 11 && mobile.test(value));  
}, lang.phoneErr); 
$.validator.addMethod("valueNotEquals", function(value, element, arg){
	return arg !== value;
}, lang.selectAnItem);
$.extend($.validator.messages, {
	required: lang.required,
	email: lang.emailErr,
	digits: lang.digits
});


// window.$ = $;
// window.layer = layer;

(() => {
	// console.log(glsl);

	// 测试用
	const domLoop = document.querySelectorAll('[data-loop]');
	if (domLoop) {
		domLoop.forEach(item => {
			const len = item.getAttribute('data-loop');
			const sourceItem = item.innerHTML;
			for (let i = 0; i < len; i++) {
				// console.log(item.innerHTML);
				// item.appendChild(item.innerHTML);
				item.innerHTML += sourceItem
			}
		});
	}
	
	const $body = document.body;
	window.lenis = new Lenis();

	window.lenis.on('scroll', ({ animatedScroll, limit, velocity, direction, progress }) => {
		animatedScroll > 60 ? $body.classList.add('fixed-menu') : $body.classList.remove('fixed-menu')
		direction > 0 ? $body.classList.add('drop-menu') : $body.classList.remove('drop-menu')
	});

	function raf(time) {
		window.lenis.raf(time);
		requestAnimationFrame(raf);
	}

	requestAnimationFrame(raf);

	var scrollEvent = new Event('scroll');
	// 触发 window 上的 scroll 事件
	window.dispatchEvent(scrollEvent);

	$('.js-backtop').on('click', function() {
		window.lenis.scrollTo(0);
	});

})();

// Header
(() => {

	$('.js-btn-menu').on('click', function(){
		$('body').toggleClass('menu-open');
	});

	$('.hm-li').on('mouseenter', function(){
		$(this).addClass('current').siblings().removeClass('current');
		const index = $(this).index();
		$('.hm-li').each((i, item) => {
			if (index === i) {
				$(item).find('.hms-ul').slideDown('fast');
			} else {
				$(item).find('.hms-ul').slideUp('fast');
			}
		});
	});

})();

// Index 
(() => {
	if (document.querySelector('.page-index')) {

		import('./page/index').then((res) => {
			res.default();
		});

		$('.itea-menu__li').on('mouseenter', function(e){
			const i = $(this).index();
			if (i == 3) {
				$('.js-index-sign').removeClass('opacity-30').addClass('opacity-100');
			} else {
				$('.js-index-sign').removeClass('opacity-100').addClass('opacity-30');
			}
		});
	}
})();

// Footer
(() => {
	if ($('.js-select2').length) {
		if ($('.js-select2').length) {
			// console.log('ttt');
			$('.js-select2').each(function(index, item){
				const placeholder = $(item).attr('aria-placeholder');
				const isPrefix = $(item).attr('data-prefix');
				const dropdownBg = $(item).attr('data-dropdown-bg');
				const isCloseOnSelect = $(item).attr('data-closeOnSelect');
				$(item).select2({
					placeholder: placeholder,
					minimumResultsForSearch: Infinity,
					dropdownParent: $('#select2Dropdown'),
					closeOnSelect: isCloseOnSelect == 'false' ? false : true,
					templateSelection: function (data) {
						if (data.id === '') { // adjust for custom placeholder values
							return placeholder;
						} else {
							if (isPrefix == "true") {
								return placeholder+data.text;
							} else {
								return data.text;
							}
							
						}
						
					}
				});
				$(item).on('select2:open', function(){
					setTimeout(() => {
						$('.lform-select2-dropdown').addClass(dropdownBg);
					}, 10);
					
				});
				$(item).on('select2:close', function(){
					$('.lform-select2-dropdown').removeClass(dropdownBg);
				});
			})
		}
	}

	$('.js-comm-layer__close').on('click', function(){
		$('.js-layer-bg').fadeOut('300');
		$(this).parents('.comm-layer').fadeOut('300')
		$('.js-select2').select2('close');
		// $('.lform-select2-dropdown').removeClass('yellow');
	});

	$('.js-show-audience').on('click', function(){
		$('.comm-layer__audience, .js-layer-bg').fadeIn('300');
	});

	$('.js-show-exhibition').on('click', function(){
		$('.comm-layer__exhibition, .js-layer-bg').fadeIn('300');
		// $('.lform-select2-dropdown').addClass('yellow');
	});

	$('.js-closed-audience').on('click', function(){
		layer.msg('您报名的展会已结束');
	});

	$('.js-closed-exhibition').on('click', function(){
		layer.msg('您报名的展会已结束');
	});

	

	// 观展
	if ($('#audienceForm').length) {
		let isSubmit = true;
		const form = $('#audienceForm');
		const btnSubmit = form.find('.btn-submit');
		form.validate({
			submitHandler: function(form) {
				if (isSubmit) {
					isSubmit = false;
					const postURL = $(form).attr('action');
					const postData = $(form).serialize();

					axios.post(postURL, postData)
					.then(function (res) {
						if (res.data.code == '200') {
							layer.msg(res.data.msg);
							$('#audienceForm')[0].reset();
							$('.js-select2-purpose').val(null).trigger('change').val('');
						} else {
							layer.msg(res.data.msg);
						}
						isSubmit = true;
					})
					.catch(function (err) {
						layer.msg(err.data.msg);
						isSubmit = true;
					});
				}
			},
			rules: {
				exhibition_id: {
					required: true
				},
				name: {
					required: true
				},
				gender: {
					required: true
				},
				age: {
					required: true,
					digits: true
				},
				phone: {
					required: true,
					isMobile: true
				},
				purpose: {
					required: true
				}
			}
		})
		btnSubmit.on('click', function(){
			form.submit();
		});
	}

	// 参展
	if ($('#exhibitionForm').length) {
		let isSubmit = true;
		const form = $('#exhibitionForm');
		const btnSubmit = form.find('.btn-submit');
		form.validate({
			submitHandler: function(form) {
				if (isSubmit) {
					isSubmit = false;
					const postURL = $(form).attr('action');
					const postData = $(form).serialize();

					axios.post(postURL, postData)
					.then(function (res) {
						if (res.data.code == '200') {
							// console.log(res);
							layer.msg(res.data.msg);
							$('#exhibitionForm')[0].reset();
						} else {
							layer.msg(res.data.msg);
						}
						isSubmit = true;
					})
					.catch(function (err) {
						layer.msg(err.data.msg);
						isSubmit = true;
					});
				}
			},
			rules: {
				exhibition_id: {
					required: true
				},
				company: {
					required: true
				},
				name: {
					required: true
				},
				business: {
					required: true
				},
				area: {
					required: true
				},
				phone: {
					required: true,
					isMobile: true
				},
				msg: {
					required: true
				}
			}
		})
		btnSubmit.on('click', function(){
			form.submit();
		});
	}

})();

// About
(() => {

	if (document.querySelector('.page-header')) {

		const yp = $('.js-ph-img').attr('data-yPercent');
		const s = $('.js-ph-img').attr('data-scale');
		// console.log(yp);
		gsap.set('.js-ph-other', { opacity: 0 });
		gsap.set('.js-ph-img', { yPercent: yp, scale: s });
		// gsap.set('.js-ph-06', { opacity: 0 });
		const tl = gsap.timeline();
		tl.addLabel('step1');
		tl.to('.js-ph-img', { yPercent: 0, scale: .26, duration: 1}, "step1+=1" );
		tl.to('.js-ph-other', { opacity: .3, duration: 1}, "step1+=1" );
		tl.to('.js-ph-other', {opacity: 1, duration: 1});
	}

	if (document.querySelector('.js-splide-about-dimg')) {
		const splideAboutDimg = new Splide('.js-splide-about-dimg', {

		}).mount();

		const splideAboutDintro = new Splide('.js-splide-about-dintro', {

		}).mount();

		splideAboutDimg.sync(splideAboutDintro);


		splideAboutDimg.on('move', (index, prev, dest)  => {
			$('.js-about-dnav > li').removeClass('current');
			$('.js-about-dnav > li').eq(index).addClass('current');
			
		});

		const bar = document.querySelector('.aboutd-progress-bar');

		splideAboutDimg.on( 'mounted move', function () {
			const end  = splideAboutDimg.Components.Controller.getEnd() + 1;
			const rate = Math.min( ( splideAboutDimg.index + 1 ) / end, 1 );
			bar.style.width = String( 100 * rate ) + '%';
		} );

		$('.js-about-dnav > li').on('click', function(){
			splideAboutDimg.go($(this).index());
		});
	}

	if (document.querySelector('.js-splide-aboute')) {
		const splideAboute = new Splide('.js-splide-aboute', {
			breakpoints: {
				768: {
					pagination: true
				}
			}
		}).mount();

		splideAboute.on('move', (index, prev, dest)  => {
			$('.aboute-item').removeClass('current');
			$('.aboute-item').eq(index).addClass('current');
		});

		$('.aboute-item').on('click', function(){
			splideAboute.go($(this).index());
		});

	}

	if (document.querySelector('.js-splide-history')) {
		const splideHistory = new Splide('.js-splide-history', {
			perPage: 6,
			breakpoints: {
				1280: {
					perPage: 5
				},
				768: {
					perPage: 3
				}
			}
		}).mount();

		const splideHistoryt = new Splide('.js-splide-aboutht', {

		}).mount();

		splideHistory.sync(splideHistoryt);

		$('.js-history-prev').on('click', function(){
			splideHistory.go('<');
		});
		$('.js-history-next').on('click', function(){
			splideHistory.go('>');
		});

	}


	$('.js-list-expos > li').on('mouseenter', function(){
		$(this).prev('li').addClass('prev');
	});
	$('.js-list-expos > li').on('mouseleave', function(){
		$(this).prev('li').removeClass('prev');
	});

	if (document.querySelector('.js-partner')) {
		const li = $('.js-partner > li');
		const len = li.length;
		const perRow = window.innerWidth > 768 ? 5 : 3;

		const firstRowLast = len > perRow ? perRow : len;
		const lastRowFirst = (Math.ceil(len / perRow) - 1) * perRow;

		if ((Math.ceil(len / perRow) > 1) && (len % perRow != 0)) {
			li.eq(lastRowFirst - 1).addClass('bottom-right');
		}

		li.eq(firstRowLast - 1).addClass('top-right');
		li.eq(lastRowFirst).addClass('bottom-left');
	}

	if (document.querySelector('.js-pjax-container')) {
		const pjax = new Pjax({
			scrollTo: false,
			elements: "a.js-pjax",
			selectors: [
				'title', 'meta[name=description]', 'meta[name=keywords]', '.js-pjax-container'
			]
		});
	}


	if (document.querySelector('.js-animnum-box')) {
		const nums = document.querySelectorAll('.js-animnum');
		nums.forEach((item, index) => {
			const id = item.getAttribute('id');
			const num = item.innerText;
			// console.log(num.length);
			const sval = Math.pow(1, num.length - 1);
			const countUp = new CountUp(id, num, { enableScrollSpy: true, duration: 2, separator: '', startVal: sval, scrollSpyOnce: true, easingFn: function (t, b, c, d) {
				var ts = (t /= d) * t;
				var tc = ts * t;
				return b + c * (tc * ts + -5 * ts * ts + 10 * tc + -10 * ts + 5 * t);
			}});
		});
    }

})();

// Expos Map
(function exposMap(){

	if (document.querySelector('.expos-map')) {
		import('./page/highmaps').then((res) => {
			res.default();
		})
	}

	if (document.querySelector('.js-expos-default')) {
		$('.js-select2').on('change', function(){
			// console.log($(this).val());
			const type = $('.js-select2-type').val();
			const year = $('.js-select2-year').val();
			let url = '/tea-expos';
			if (type) {
				url += `?type=${type}`
			}
			if (year) {
				url += type ? `&year=${year}` : `?year=${year}`
			}
			// console.log(url);
			axios.get(url).then((res) => {
				// console.log(res.data);
				// console.log();
				const str = $(res.data).find('.js-list-box').html();
				console.log(str);
				$('.js-list-box').html(str)

				// const eArr = JSON.parse(str);

			})
		});
	}

})();

(function stickyNav(){
	if ($('.js-sticky-nav').length) {

		const sticky = new Sticky('.js-sticky-nav');

		if (document.querySelector('.js-sticky-link')) {
			$(window).on('scroll', function(){
				const sTop = $(window).scrollTop(),
					headerH = $('.header').outerHeight();
				let id = '';
				$('.sticky-section').each(function(index, item) {
					const oTop = $(item).offset().top - headerH;
					if (sTop > oTop - 10) {
						id = $(item).attr('id');
					}
				});
				if (id == '') {
					id = $('.sticky-section').eq(0).attr('id');
				}
	
				console.log(id);
				$('.js-sticky-link').each(function(index, item){
					if ($(item).attr('href') == '#'+id) {
						$(item).addClass('current');
					} else {
						$(item).removeClass('current');
					}
				});
			});
			$('.js-sticky-link').on('click', function(e){
				e.preventDefault();
				const id = $(this).attr('href');
				const top = $(id).offset().top + 1 - $('.header').outerHeight();
				window.lenis.scrollTo(top);
			});
		}
		
	}


	$('.sbnav-item').on('click', function() {
		if ($(this).data('id')) {
			const top = $('#'+$(this).data('id')).offset().top + 1;
			lenis.scrollTo(top);
		}
	});

})();

// INIT
(() => {
	// Lazyload data-src data-bg data-poster
	// var myLazyLoad = new LazyLoad({
	// 	threshold: 800
	// });

	if (document.querySelector('.citys')) {
		$('.citys').citys({
			url : '/themes/cn/assets/jquery-citys.json',          // 省市区json数据地址
			province : '',                        // 省份(省级),可以为地区编码或者省份名称
			city : '',                            // 城市(地级),可以为地区编码或者城市名称
			area : '',                            // 地区(县区级),可以为地区编码或者地区名称
			type : 'name',                        // 下拉框值的类型,code行政区划代码,name地名
			selProvince : "province",             // 省份、直辖市列表框name
			selCity : "city",                     // 城市、区列表框name
		  });
	}

	

	if ($('.js-video-item').length) {
		$('.js-video-item__btn').on('click', function(){
			const box = $(this).parents('.js-video-item');
			if (!box.find('video').length) {
				return false;
			}
			
			const isPlay = box.attr('data-play');
			const video = box.find('video')[0];
			// console.log(isPlay)
			if (isPlay == 'true') {
				video.pause();
				box.attr('data-play', false);
			} else {
				video.play();
				box.attr('data-play', true);
			}
		});
	}

	$('.js-list-more').on('click', function(){
		const box = $(this).parents('.list-box');
		box.toggleClass('show');
	})

	// Social Share
	const share = new SimpleShare({
		url: '',
		title: '',
		content: '',
		pic: ''
	});
	const shareLinks = document.querySelectorAll('[data-share]');
	shareLinks.forEach(link => {
		link.addEventListener('click', () => {
			share.goShare(link.getAttribute('data-share'));
		})
	});


	if (document.querySelector('.dshare-weixin')) {
		const url = encodeURIComponent(window.location.href);
		// let wxQrcode = new Image();
        // wxQrcode.src = ``;
		const temp = `<div class="dshare-weixin__img absolute bottom-full text-12 text-black bg-white"><img src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data={${url}}" /><p>分享到微信朋友圈</p></div>`;
		$('.dshare-weixin').append(temp);
	}

	AOS.init({
		duration: 800
	});

	let fontsize = [12, 14, 16, 18, 20, 24, 32, 36, 40, 48, 54, 64, 72, 80, 84, 120, 680];
	let str = '';
	for (let i = 0; i < fontsize.length; i++) {
		str += `'${fontsize[i]}': '${fontsize[i]}px',\n'hd${fontsize[i]}': '${(fontsize[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('font-size:');
	// console.log(str);

	let maxWArr = [840, 1100, 1150, 1280, 1440];
	let maxW = '';
	for (let i = 0; i < maxWArr.length; i++) {
		maxW += `'${maxWArr[i]}': '${maxWArr[i]}px',\n'hd${maxWArr[i]}': '${(maxWArr[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('max-width:');
	// console.log(maxW);

	let spaceArr = [1, 5, 10, 15, 16, 20, 26, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 140, 160, 180, 200, 300, 400, 1000];
	let space = '';
	for (let i = 0; i < spaceArr.length; i++) {
		space += `'${spaceArr[i]}': '${spaceArr[i]}px',\n'hd${spaceArr[i]}': '${(spaceArr[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('spacing:');
	// console.log(space);

	let roundedArr = [4, 5, 10, 20];
	let rounded = '';
	for (let i = 0; i < roundedArr.length; i++) {
		rounded += `'${roundedArr[i]}': '${roundedArr[i]}px',\n'hd${roundedArr[i]}': '${(roundedArr[i]/19.2).toFixed(4)}vw',\n`
	}
	// console.log('rounded:');
	// console.log(rounded);

})();

// CookieConsent
(() => {
	/**
	 * All config. options available here:
	 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
	*/
	document.documentElement.classList.add('cc--defaultmode');
	
	CookieConsent.run({

		categories: {
			necessary: {
				enabled: true,  // this category is enabled by default
				readOnly: true  // this category cannot be disabled
			},
			required: {
				enabled: true,  // this category is enabled by default
				readOnly: false  // this category cannot be disabled
			},
			analytics: {}
		},

		guiOptions: {
			consentModal: {
				layout: 'bar',
				position: 'bottom',
				flipButtons: false,
				equalWeightButtons: true
			},
			preferencesModal: {
				layout: 'box',
				// position: 'left right',
				flipButtons: false,
				equalWeightButtons: true
			}
		},

		language: {
			default: 'en',

			translations: {
				en: {

					consentModal: {
						title: '',
						description: 'We use our own and third-party cookies to ensure the proper functioning of the web portal and its complements, perform navigation analysis and show multimedia content. If you continue browsing, you accept the use of this technology. For more information please see our Cookies Policy. <a href="/cookie-statement" style="text-decoration:underline;">Learn more</a>',
						acceptAllBtn: 'Accept all',
						acceptNecessaryBtn: 'Reject all',
						showPreferencesBtn: 'Customize'
					},
					preferencesModal: {
						title: 'Manage cookie preferences',
						acceptAllBtn: 'Save settings',
						acceptNecessaryBtn: 'Reject all',
						savePreferencesBtn: 'Accept current selection',
						closeIconLabel: 'Close modal',
						sections: [
							// {
							// 	title: 'Somebody said ... cookies?',
							// 	description: 'I want one!'
							// },
							{
								title: 'Technically required',
								description: 'Required web technologies and cookies make our website technically accessible to and usable for you. This applies to fundamental base functionalities such as navigation on the website, correct display in your internet browser or requesting your consent. Without these web technologies and cookies our website does not work.',

								//this field will generate a toggle linked to the 'required' category
								linkedCategory: 'required'
							},
							{
								title: 'Analysis and statistics',
								description: 'We want to constantly improve the user-friendliness and performance of our websites. For this reason we use analysis technologies (including cookies) which pseudonymously measure and evaluate which functions and content of our websites are used, how and how often. On this basis we can improve our websites for users.',
								linkedCategory: 'analytics'
							}
							// ,
							// {
							// 	title: 'More information',
							// 	description: 'For any queries in relation to my policy on cookies and your choices, please <a href="#contact-page">contact us</a>'
							// }
						]
					}
				}
			}
		}
	});
});